import { useState } from 'react';

import { Box } from '@chakra-ui/react';
import {
  Avatar,
  AvatarImage,
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
  ListItemComp,
  ListItemCompContent,
  ListItemCompLeading,
  ListItemCompTitle,
} from '@mesh.ai/rabbit';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { LIFECYCLE_DEMO_EMPLOYEES } from '../constants/employees';

export const EmployeeMetaFilterDropdown = () => {
  const [selectedEmployee, setSelectedEmployee] = useState('1');

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip className="chip-dropdown">
          <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]" mr="4px">
            Employee name:
          </TextBodyMedium>
          <Box display="inline-flex" alignItems="center" justifyContent="center" gap="4px">
            <Avatar size="xs">
              <AvatarImage src={LIFECYCLE_DEMO_EMPLOYEES[selectedEmployee].img} />
            </Avatar>
            <TextBodyMedium bold color="text.g1">
              {LIFECYCLE_DEMO_EMPLOYEES[selectedEmployee].name}
            </TextBodyMedium>
          </Box>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent align="start" style={{ minWidth: '200px', maxHeight: '400px', overflow: 'auto' }}>
        <DropdownRadioGroup value={selectedEmployee} onValueChange={(value) => setSelectedEmployee(value)}>
          {Object.entries(LIFECYCLE_DEMO_EMPLOYEES).map(([id, employee]) => (
            <DropdownRadioItem key={id} value={id}>
              <ListItemComp style={{ padding: 0 }}>
                <ListItemCompLeading>
                  <Avatar>
                    <AvatarImage src={employee.img} />
                  </Avatar>
                </ListItemCompLeading>
                <ListItemCompContent>
                  <ListItemCompTitle bold={false}>{employee.name}</ListItemCompTitle>
                </ListItemCompContent>
              </ListItemComp>
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};
